import React, { Suspense } from 'react'
import { Flex, Loading, Spinner } from 'ui/bend'

import StyledAdminWrapper from './StyledAdminWrapper'
import PersonalPlanStructure from 'components_v2/Admin/PersonalPlanStructure/PersonalPlanStructure'

const PersonalPlanStructureWrapper = ({ programId, seriesItems = [] }) => {
  return (
    <StyledAdminWrapper>
      <Loading
        loading={false}
        error={false}
        LoadingComponent={
          <Flex
            height='100vh'
            width={['100%', '75%']}
            alignItems='center'
            justifyContent='center'
          >
            <Spinner />
          </Flex>
        }
        ErrorComponent={<Flex />}
      >
        <Suspense fallback=''>
          <PersonalPlanStructure
            programId={programId}
            seriesItems={seriesItems}
          />
        </Suspense>
      </Loading>
    </StyledAdminWrapper>
  )
}

export default PersonalPlanStructureWrapper
